// src/api/v3/products-api-v3.js
import { manualDelete } from './manual-delete-api-v3';

const API_BASE = process.env.REACT_APP_API_BASE ;
const API_PREFIX = process.env.REACT_APP_API_PREFIX || '/api/v3';
const B = (p='') => `${API_BASE}${API_PREFIX}${p}`;

async function handleRes(res) {
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const j = await res.json();
      msg = j?.errors?.join(', ') || j?.error || msg;
    } catch {}
    throw new Error(msg);
  }
  return res.json();
}

async function jsonFetch(url, opts = {}) {
  const res = await fetch(url, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(opts.headers||{}) },
    ...opts,
    body: opts.body ? JSON.stringify(opts.body) : undefined
  });
  if (!res.ok) {
    const text = await res.text().catch(()=> '');
    throw new Error(`${opts.method||'GET'} ${url} failed: ${res.status} ${text}`);
  }
  return res.headers.get('content-type')?.includes('application/json') ? res.json() : null;
}

export const ProductsAPI = {
  // Accepts { q, page, per, customer_id }
  async list(params = {}) {
    const url = new URL(`${API_BASE}/api/v3/products`);
    if (params.q)            url.searchParams.set('q', params.q);
    if (params.page)         url.searchParams.set('page', params.page);
    if (params.per)          url.searchParams.set('per', params.per);
    if (params.customer_id)  url.searchParams.set('customer_id', params.customer_id);

    const res = await fetch(url.toString(), {
      credentials: 'include',
      headers: { Accept: 'application/json' },
    });
    return handleRes(res);
  },
  destroy: (id) => manualDelete(B(`/products/${id}`)),
  show: (id) => jsonFetch(B(`/products/${id}`)),
  create: (payload) => jsonFetch(B(`/products`), { method: 'POST', body: payload }),
  update: (id, payload) => jsonFetch(B(`/products/${id}`), { method: 'PUT', body: payload }),
};

export default ProductsAPI;
